import { twMerge } from 'tailwind-merge';

import { Locales } from 'constants/app';
import { setLocale } from 'store/app/slice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

const localeStyles =
  'px-3 md:px-5 py-1 md:py-[10px] rounded-xsmall md:rounded-small text-black md:text-white text-[12px] md:text-sm leading-5 font-normal h-[32px] md:h-[40px] w-[50px] md:w-[65px]';

const activeStyles = 'bg-black md:bg-white text-white md:text-black font-medium';

const SwitchLocale = () => {
  const { locale } = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();

  const changeLocale = (language: string) => {
    localStorage.setItem('locale', language);
    window.location.hash = `#${language}`;
    dispatch(setLocale(language));
  };

  return (
    <div>
      <button
        type="button"
        onClick={() => changeLocale(Locales.ru)}
        className={twMerge(localeStyles, locale === Locales.ru && activeStyles)}
      >
        Рус
      </button>
      <button
        type="button"
        onClick={() => changeLocale(Locales.kk)}
        className={twMerge(localeStyles, locale === Locales.kk && activeStyles)}
      >
        Каз
      </button>
    </div>
  );
};

export { SwitchLocale };
